"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargeOnTheGo = function IconChargeOnTheGo(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M37.953 43H9.987v-2h27.966zM25.308 12c.984 0 1.934.349 2.685.983l.184.165 8.235 7.905 8.406 1.15a3.1 3.1 0 0 1 1.924 1.106l.126.166c.443.627.637 1.394.548 2.151l-.031.207-.86 4.628a3.1 3.1 0 0 1-2.863 2.534l-.186.005H39.85a4.996 4.996 0 0 1-4.893 4 5 5 0 0 1-4.893-4H18.876a4.996 4.996 0 0 1-4.893 4 5 5 0 0 1-4.894-4H3.745a2.75 2.75 0 0 1-2.741-2.582l-.005-.168V27h1.997v3.25c0 .38.282.693.648.743l.101.007H9.09a5 5 0 0 1 4.894-4 4.996 4.996 0 0 1 4.893 4h11.188a5 5 0 0 1 4.893-4 4.996 4.996 0 0 1 4.893 4h3.628a1.1 1.1 0 0 0 1.055-.784l.029-.118.859-4.631a1.1 1.1 0 0 0-.774-1.26l-.118-.026-9.03-1.234-8.701-8.352a2.16 2.16 0 0 0-1.306-.587L25.31 14H10.986v-2zM13.983 29a3 3 0 0 0-2.997 3c0 1.657 1.343 3 2.997 3a3 3 0 0 0 2.997-3c0-1.657-1.342-3-2.997-3m20.974 0a3 3 0 0 0-2.997 3c0 1.657 1.342 3 2.997 3a3 3 0 0 0 2.996-3c0-1.657-1.341-3-2.996-3m-20.975 1.5a1.5 1.5 0 1 1-.002 2.998 1.5 1.5 0 0 1 .002-2.998m20.945 0a1.5 1.5 0 1 1-.003 2.998 1.5 1.5 0 0 1 .003-2.998m-20.945 1a.5.5 0 1 0 .001.999.5.5 0 0 0 0-.999m20.945 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M24.47 21.318l2.497-.59L22.972 29l.499-5.318-2.497.59L24.969 16zM10.986 22h-6.99v-1h6.99zm1-4H4.993v-1h6.991z"
  })));
};

export { IconChargeOnTheGo, IconChargeOnTheGo as default };
